import CampaignCustomFieldResourceListResultModel from '../../generated/types/model/resource/CampaignCustomFieldResourceListResultModel';

export default class CampaignCustomFieldResourceListResultViewModel extends CampaignCustomFieldResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
